const setToString = (value: any) => {
  if (!value || value === -1 || typeof value === 'string') {
    return value
  } else {
    return value.toString()
  }
}

export default setToString
